import React from 'react';

const Header = () => {
    return (

        <h1 className="heading">Expense Tracker</h1>
    );
};

export default Header;